import { Route, Routes } from "react-router-dom";
import './index.css'; // ✅ YEH BHI ADD KAR DO
// Import your components
import Login from "../src/Pages/Login.js";
import ForgotPassword from "./Pages/ForgotPassword.js";
import ResetPassword from "./Pages/ResetPassword.js";
import CompanySidebar from "./Components/CompanySidebar.js";
import DepartmentList from "./Components/department";
import Recruitment from "./Components/recruitment.js";
import SubDepartmentList from "./Components/subdepartment.js";
import AdminLayout from "./Layout/AdminLayout.jsx";
import AboutUsFormPage from "./Pages/AboutUsFormPage.js";
import AbsentToday from "./Pages/AbsentToday.js";
import AcceptedAppointmentsList from "./Pages/AcceptedAppointmentsList.js";
import AddEmployeePage from "./Pages/AddEmployeePage.js";
import ClientRequests from "./Pages/ClientRequests.jsx";
import Register from "./Pages/Register.jsx";

import AllFunFactsTable from "./Pages/AllFunFactsTable.js";
import AllPayments from "./Pages/AllPayments.js";
import AllQuizzesTable from "./Pages/AllQuizzesTable.js";
import AppointmentBookingForm from "./Pages/AppointmentBookingForm.js";
import AttendanceCapture from "./Pages/AttendanceCapture.jsx";
import AttendanceForm from "./Pages/AttendanceForm.js";
import AttendanceList from "./Pages/AttendanceList.js";
import DiagnosticList from "./Pages/Awardlist.js";
import BackupReset from "./Pages/BackupReset.js";
import BookingList from "./Pages/BookingList.js";
import BulkFunFactUploader from "./Pages/BulkFunFactUploader.js";
import BulkQuizUploader from "./Pages/BulkQuizUploader.js";
import CancelledBookingList from "./Pages/CancelledBookingList .js";
import CandidateSelection from "./Pages/CandidateSelection.js";
import CandidateShortlist from "./Pages/CandidateShortlist.js";
import CategoryForm from "./Pages/CategoryForm.js";
import CategoryList from "./Pages/CategoryList.js";
import ClientsTable from "./Pages/ClientsTable.js";
import CompanyDetailsForm from "./Pages/CompanyDetailsForm.js";
import CompanyList from "./Pages/CompanyList.js";
import CompletedBookingList from "./Pages/CompletedBookingList .js";
import ContactUsPage from "./Pages/ContactUsPage.js";
import CouponHistoryTable from "./Pages/CouponHistoryTable.js";
import CouponsPage from "./Pages/CouponPage.js";
import CreateBusinessCard from "./Pages/CreateBusinessCard.js";
import CreateCategory from "./Pages/CreateCategory.js";
import CreateCoupon from "./Pages/CreateCoupon.js";
import CreateLogo from "./Pages/CreateLogo.js";
import CreatePlan from "./Pages/CreatePlan.js";
import CreatePoster from "./Pages/CreatePoster.js";
import CreateProductForm from "./Pages/CreateProduct.js";
import CreateVendor from "./Pages/CreateVendor.js";
import Dashboard from "./Pages/Dashboard.jsx";
import DiagnosticBookingForm from "./Pages/DiagnosticBookingForm.js";
import DiagnosticDetail from "./Pages/DiagnosticDetail.js";
import DiagnosticsAcceptedBooking from "./Pages/DiagnosticsAcceptedBooking.js";
import DiagnosticsBookingList from "./Pages/DiagnosticsBookingList.js";
import DiagnosticsPendingBooking from "./Pages/DiagnosticsPendingBooking.js";
import DiagnosticsRejectedBooking from "./Pages/DiagnosticsRejectedBooking.js";
import DoctorAppointmentList from "./Pages/DoctorAppointmentList.js";
import DoctorAppointmentListPending from "./Pages/DoctorAppointmentListPending.js";
import DoctorDetailsForm from "./Pages/DoctorDetailsForm.js";
import DoctorList from "./Pages/DoctorList.js";
import DocumentTable from "./Pages/DocumentTable.js";
import EmployeeDashboard from "./Pages/EmployeeDashboard.jsx";
import EmployeeLeaves from "./Pages/EmployeeLeaves.js";
import EmployeeNotifications from "./Pages/EmployeeNotifications.js";

import EmployeeList from "./Pages/EmployeeList.js";
import GetAboutUsPage from "./Pages/GetAboutUsPage.js";
import GetContactUsPage from "./Pages/GetContactUsPage.js";
import Holiday from "./Pages/Holiday.js";
import InterviewList from "./Pages/InterviewList.js";
import LanguageSetup from "./Pages/LanguageSetup.js";
import LateToday from "./Pages/LateToday.js";
import { default as DiagnostiCreate, default as LeaveApplication } from "./Pages/LeaveApplication.js";
import LeaveApproval from "./Pages/LeaveApproval";
import Leaves from "./Pages/Leaves.js";
import LeavesList from "./Pages/LeavesList.js";
import LogoList from "./Pages/LogoList.js";
import ManageProjects from "./Pages/ManageProject.js";
import MessagesTable from "./Pages/Message.js";
import MissingAttendance from "./Pages/MissingAttendance.js";
import MonthlyAttendance from "./Pages/MonthlyAttendance.js";
import MyAttendance from "./Pages/MyAttendance.js";
import NoticeList from "./Pages/Noticelist.js";
import OrdersList from "./Pages/OrdersList.js";
import PendingAttendance from "./Pages/PendingAttendance.js";
import PendingBookingList from "./Pages/PendingBookingList.js";
import PlanList from "./Pages/PlanList.js";
import PosterList from "./Pages/PosterList.js";
import PrivacyPolicyForm from "./Pages/PrivacyPolicyForm.js";
import PrivacyPolicyPage from "./Pages/PrivacyPolicyPage.js";
import ProductList from "./Pages/ProductList.js";
import ProjectsTable from "./Pages/ProjectsTable.js";
import ProjectTasksTable from "./Pages/ProjectTasksTable.js";
import ReceivedPayments from "./Pages/ReceivedPayments.js";
import RedeemedCouponsList from "./Pages/RedeemedCouponsList.js";
import RejectedAppointmentsList from "./Pages/RejectedAppointmentsList.js";
import SentMessagesTable from "./Pages/Sent.js";
import Settings from "./Pages/Setting";
import SetupRulesTable from "./Pages/Setup.js";
import StaffDetailsForm from "./Pages/StaffDetailsForm.js";
import StaffHistory from "./Pages/StaffHistory.js";
import StaffList from "./Pages/StaffList.js";
import TodayAttendance from "./Pages/TodayAttendance.js";
import UploadDocuments from "./Pages/UploadDocuments.js";
import AllUserCoupons from "./Pages/userCoupons.js";
import UserList from "./Pages/UserList.js";
import UserDetail from "./Pages/UserProfile.js";
import UsersPlansList from "./Pages/UsersPlansList.js";
import VendorDocumentList from "./Pages/VendorDocumentList.js";
import VendorInvoiceList from "./Pages/VendorInvoiceList.js";
import VendorList from "./Pages/VendorList.js";
import VendorDetail from "./Pages/VendorProfile.js";
import WeeklyHoliday from "./Pages/WeeklyHoliday.js";
// import LandingPage from "./Pages/LandingPage.js";
import EmployeeDetailsModal from "./Components/EmployeeDetailsModel.js";
import TimelyNavbar from "./Components/TimelyNavbar.js";
import CandidateLayout from "./Layout/CandidateLayout.jsx";
import EmployeeLayout from "./Layout/EmployeeLayout.jsx";
import AboutPage from "./Pages/AboutPage.js";
import AdminEmployeeLocations from "./Pages/AdminEmployeeLocations.js";
import AdminNotifications from "./Pages/AdminNotifications.js";
import AssignLocation from "./Pages/AssignLocation.js";
import AttendanceSummary from "./Pages/AttendanceSummary.js";
import ContactPage from "./Pages/ContactPage.js";
import DepartmentDashboard from "./Pages/DepartmentDashboard.js";
import EmployeeLocation from "./Pages/EmployeeLocation.js";
import EmployeeSalary from "./Pages/EmployeeSalary.js";
import HomePage from "./Pages/HomePage.js";
import LeavesReport from "./Pages/LeavesReport.js";
import AddLocationPage from "./Pages/Location.js";
import LocationListPage from "./Pages/LocationListPage.js";
import MyPermission from "./Pages/MyPermission.js";
import MyShift from "./Pages/MyShift.js";
import PayRoll from "./Pages/PayRoll.js";
import { Permissions } from "./Pages/Permissions.js";
import RoleDashboard from "./Pages/RoleDashboard.js";
import ServicesPage from "./Pages/ServicesPage.js";
import ShiftList from "./Pages/ShiftList.js";
import ShiftManagement from "./Pages/ShiftManagement.js";
import SuperAdminMedicalMonitor from "./Pages/SuperAdminMedicalMonitor.js";
import TimelyFooter from "./Pages/TimelyFooter.js";
import UserAccessManagement from "./Pages/UserAccessManagement.js";
import UserActivity from "./Pages/UserActivity.js";
import WhoWeServePage from "./Pages/WhoWeServePage.js";
// import EmpManagment from "./Pages/EmpManagment.js";

import CandidateDashboard from "./Pages/CandidateDashboard.jsx";
import JobApplicants from "./Pages/JobApplicants.jsx";
import JobDetails from "./Pages/JobDetails.jsx";
import JobPost from "./Pages/JobPost.jsx";
import PersonalDocuments from "./Pages/PersonalDocuments.jsx";
import Score from "./Pages/Score.jsx";
import SendOffer from "./Pages/SendOffer.jsx";

import AssessmentManager from "./Pages/AssessmentManager.jsx";
// import CandidateDashboard from "./Pages/CandidateDashboard.jsx";
import CandidateLogin from "./Pages/CandidateLogin.jsx";
import CandidateRegister from "./Pages/CandidateRegister.jsx";

// import Documents from "./Pages/Documents.jsx";
// import PersonalDocuments from "./Pages/PersonalDocuments.jsx";
import Medical from "./Pages/Medical.jsx";
// import PersonalDocumets from "./Pages/PersonalDocumets.jsx";
// import PersonalDocuments from "./Pages/PersonalDocuments.jsx";
import AllJobs from "./Pages/AllJobs.jsx";
import AppliedJobs from "./Pages/AppliedJobs.jsx";
import CandidateDocuments from "./Pages/CandidateDocuments.jsx";
import CandidatePersonalDocuments from "./Pages/CandidatePersonalDocuments.jsx";
import EmployeeJourney from "./Pages/EmployeeJourney.jsx";
import EmployeeLetters from "./Pages/EmployeeLetters.jsx"; // ✅ New import
import EmployeePersonalDocuments from "./Pages/EmployeePersonalDocuments.jsx";
import EmployeeResignation from "./Pages/EmployeeResignation.jsx";
import Interview from "./Pages/Interview.jsx";
import Letters from "./Pages/Letters.jsx";
import MyJobs from "./Pages/MyJobs.jsx";
import RecruitmentDashboard from "./Pages/RecruitmentDashboard.jsx";
// import ExpenseManagement from "./Pages/ExpenseManagement.jsx";
import AllExpensives from "./Pages/AllExpensives.jsx";
import ExpenseManagement from "./Pages/ExpenseManagement.jsx";

import Documents from "./Pages/Documents.jsx";
// import JobApplicants from "./Pages/JobApplicants.jsx";
// import JobDetails from "./Pages/JobDetails.jsx";
// import JobPost from "./Pages/JobPost.jsx";
// import Medical from "./Pages/Medical.jsx";
// import Score from "./Pages/Score.jsx";
// import SendOffer from "./Pages/SendOffer.jsx";
import AllMedicalCertificate from "./Pages/AllMedicalCertificate.jsx";
import ApplyingJob from "./Pages/ApplyingJob.jsx";
import ApprovedLeaves from "./Pages/ApprovedLeaves.jsx";
import MedicalCertificate from "./Pages/MedicalCertificate.jsx";
import MyMedicalCertificate from "./Pages/MyMedicalCertificate.jsx";
import Occasions from "./Pages/Occasions.jsx";
import PendingLeaves from "./Pages/PendingLeaves.jsx";
import Regularization from "./Pages/Regularization.jsx";
import RejectedLeaves from "./Pages/RejectedLeaves.jsx";
import TakeAssessment from "./Pages/TakeAssessment.jsx";
// import ProductList from"./Pages/Productlist.js";
import HolidayList from "./Pages/Holiday.js";
import HolidaysCalendar from "./Pages/HolidaysCalendar.jsx";
import ProductSelectionPage from "./Pages/ProductSelectionPage.jsx";
import BankReports from "./Pages/BankReports.js";
import ApprovedResignations from "./Pages/ApprovedResignations.jsx";
import RejectedResignations from "./Pages/RejectedResignations.jsx";
import PendingResignations from "./Pages/PendingResignations.jsx";
import Events from "./Pages/Events.jsx";
import EmployeeProfileCombined from "./Pages/EmployeeProfileCombined.jsx";
import OverTime from "./Pages/OverTime.jsx";
import CompOffSettings from "./Pages/CompOffSettings.js";


function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />}></Route>
      {/* Login page rendered outside AdminLayout */}
      {/* <Route path="/land" element={<LandingPage />} /> */}
      {/* <Route path="/" element={<LoginPage />} /> */}
      <Route path="/register" element={<Register />} />
      <Route path="/productlist" element={<ProductList />} />
      <Route path="/productselection" element={<ProductSelectionPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password/:token" element={<ResetPassword />} />
      <Route path="/admin-login" element={<Login />} />
      <Route path="/employee-login" element={<Login />} />
      <Route path="/candidate-login" element={<CandidateLogin />} />
      <Route path="/candidate-register" element={<CandidateRegister />} />
      <Route path="/employeedashboard" element={<EmployeeLayout><EmployeeDashboard /></EmployeeLayout>} />
      <Route path="/leave-application" element={<EmployeeLayout><LeaveApplication /></EmployeeLayout>} />
      <Route path="/myleaves" element={<EmployeeLayout><EmployeeLeaves /></EmployeeLayout>} />
      <Route path="/attendance-capture" element={<EmployeeLayout><AttendanceCapture /></EmployeeLayout>} />
      <Route path="/myattendance" element={<EmployeeLayout><MyAttendance /></EmployeeLayout>} />
   
      <Route path="/my-shift" element={<EmployeeLayout><MyShift /></EmployeeLayout>} />
      <Route path="/mypermissions" element={<EmployeeLayout><MyPermission /></EmployeeLayout>} />
      {/* <Route path="/expense-management" element={<ExpenseManagement />} />   */}
      <Route path="/expense-management" element={<EmployeeLayout><ExpenseManagement /></EmployeeLayout>} />
      <Route path="/emp-profile" element={<EmployeeLayout><EmployeeProfileCombined /></EmployeeLayout>} />
      <Route path="/emp-my-jobs" element={<EmployeeLayout><MyJobs /></EmployeeLayout>} />
      <Route path="/emp-personal-documents" element={<EmployeeLayout><EmployeePersonalDocuments /></EmployeeLayout>} />
      <Route path="/emp-letters" element={<EmployeeLayout><EmployeeLetters /></EmployeeLayout>} />

      <Route path="/mylocation" element={<EmployeeLayout><EmployeeLocation /></EmployeeLayout>} />
      <Route path="/jobs/:id" element={<JobDetails />} />
      <Route path="/assessment/:jobId/:applicationId" element={<TakeAssessment />} />
      <Route path="/assessment/:jobId/:applicationId/:quizId" element={<TakeAssessment />} />
      <Route path="/applying-job/:jobId" element={<ApplyingJob />} />
      {/* ✅ Candidate Portal Routes with Shared Layout */}
      <Route element={<CandidateLayout />}>
        <Route path="/candidate-dashboard" element={<CandidateDashboard />} />
          
        <Route path="/medical-certificate" element={<MedicalCertificate />} />
        <Route path="/all-jobs" element={<AllJobs />} />
        <Route path="/applied-jobs" element={<AppliedJobs />} />
        <Route path="/interview" element={<Interview />} />
        <Route path="/letters" element={<Letters />} />
        <Route path="/candidate-documents" element={<CandidateDocuments />} />
        <Route path="/candidate-personal-documents" element={<CandidatePersonalDocuments />} />
        <Route path="/my-jobs" element={<MyJobs />} />
      </Route>

      <Route path="/superadmin" element={<SuperAdminMedicalMonitor />} />
      <Route path="/timelynavbar" element={<TimelyNavbar />}></Route>
      <Route path="timelyfooter" element={<TimelyFooter />}></Route>
      <Route path="/about" element={<AboutPage />}></Route>
      <Route path="/service" element={<ServicesPage />}></Route>
      <Route path="/whoweserve" element={<WhoWeServePage />}></Route>
      <Route path="/contact" element={<ContactPage />}></Route>
      <Route path="/mysalary" element={<EmployeeLayout><EmployeeSalary /></EmployeeLayout>} />
      <Route path="/HolidayList" element={<EmployeeLayout><HolidayList /></EmployeeLayout>} />

      {/* ✅ Shared Admin Features for Employees (Wrapped in EmployeeLayout) */}
      <Route path="/emp-employees" element={<EmployeeLayout><EmployeeList /></EmployeeLayout>} />
      <Route path="/emp-attendance-summary" element={<EmployeeLayout><AttendanceSummary /></EmployeeLayout>} />
      <Route path="/emp-attendance-records" element={<EmployeeLayout><AttendanceList /></EmployeeLayout>} />
      <Route path="/emp-today-attendance" element={<EmployeeLayout><TodayAttendance /></EmployeeLayout>} />
      <Route path="/emp-absent-today" element={<EmployeeLayout><AbsentToday /></EmployeeLayout>} />
      <Route path="/emp-leaves" element={<EmployeeLayout><LeavesList /></EmployeeLayout>} />
      <Route path="/emp-pending-leaves" element={<EmployeeLayout><PendingLeaves /></EmployeeLayout>} />
      <Route path="/emp-approved-leaves" element={<EmployeeLayout><ApprovedLeaves /></EmployeeLayout>} />
      <Route path="/emp-rejected-leaves" element={<EmployeeLayout><RejectedLeaves /></EmployeeLayout>} />
      <Route path="/emp-add-holiday" element={<EmployeeLayout><HolidaysCalendar /></EmployeeLayout>} />
      <Route path="/emp-payroll" element={<EmployeeLayout><PayRoll /></EmployeeLayout>} />
      <Route path="/emp-reports" element={<EmployeeLayout><LeavesReport /></EmployeeLayout>} />
      <Route path="/emp-locations" element={<EmployeeLayout><LocationListPage /></EmployeeLayout>} />
      <Route path="/emp-shifts" element={<EmployeeLayout><ShiftManagement /></EmployeeLayout>} />
      <Route path="/emp-user-activity" element={<EmployeeLayout><UserActivity /></EmployeeLayout>} />
      <Route path="/emp-add-employee" element={<EmployeeLayout><AddEmployeePage /></EmployeeLayout>} />
      <Route path="/emp-admin-dashboard" element={<EmployeeLayout><Dashboard /></EmployeeLayout>} />
      <Route path="/emp-user-access" element={<EmployeeLayout><UserAccessManagement /></EmployeeLayout>} />
      <Route path="/emp-add-location" element={<EmployeeLayout><AddLocationPage /></EmployeeLayout>} />
      <Route path="/emp-notifications" element={<EmployeeLayout><EmployeeNotifications /></EmployeeLayout>} />
      <Route path="/emp-job-posts" element={<EmployeeLayout><JobPost /></EmployeeLayout>} />
      <Route path="/emp-job-applicants" element={<EmployeeLayout><JobApplicants /></EmployeeLayout>} />
      <Route path="/emp-score-board" element={<EmployeeLayout><Score /></EmployeeLayout>} />
      <Route path="/emp-assessments" element={<EmployeeLayout><AssessmentManager /></EmployeeLayout>} />
      <Route path="/emp-documents" element={<EmployeeLayout><Documents /></EmployeeLayout>} />
      <Route path="/emp-permissions" element={<EmployeeLayout><Permissions /></EmployeeLayout>} />
      <Route path="/emp-holidays-calendar" element={<EmployeeLayout><HolidaysCalendar /></EmployeeLayout>} />
      <Route path="/emp-all-expensives-management" element={<EmployeeLayout><AllExpensives /></EmployeeLayout>} />
      <Route path="/my-medical-certificate" element={<EmployeeLayout><MyMedicalCertificate /></EmployeeLayout>} />
      <Route path="/emp-events" element={<EmployeeLayout><Events /></EmployeeLayout>} />
      {/* All other routes inside AdminLayout */}
      <Route
        path="/*"
        element={
          <AdminLayout>
            <Routes>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/department" element={<DepartmentList />} />
              <Route path="/subdepartment" element={<SubDepartmentList />} />
              <Route path="/attendanceform" element={<AttendanceForm />} />
              <Route path="/monthlyattendance" element={<MonthlyAttendance />} />
              <Route path="/missingattendance" element={<MissingAttendance />} />
              <Route path="/weeklyholiday" element={<WeeklyHoliday />} />
              <Route path="/holiday" element={<Holiday />} />
              <Route path="/create-diagnostic" element={<DiagnostiCreate />} />
              <Route path="/leaves" element={<Leaves />} />
              <Route path="/leaveapproval" element={<LeaveApproval />} />
              <Route path="/recruitment" element={<Recruitment />} />
              <Route path="/setting" element={<Settings />} />
              <Route path="/languagesetup" element={<LanguageSetup />} />
              <Route path="/backupreset" element={<BackupReset />} />
              <Route path="/diagnosticlist" element={<DiagnosticList />} />
              <Route path="/message" element={<MessagesTable />} />
              <Route path="/noticelist" element={<NoticeList />} />
              <Route path="/sentlist" element={<SentMessagesTable />} />
              <Route path="/setuplist" element={<SetupRulesTable />} />
              <Route path="/candidate-shortlist" element={<CandidateShortlist />} />
              <Route path="/interviewlist" element={<InterviewList />} />
              <Route path="/selectedcandidates" element={<CandidateSelection />} />
              <Route path="/clients" element={<ClientsTable />} />
              <Route path="/projects" element={<ProjectsTable />} />
              <Route path="/task" element={<ProjectTasksTable />} />
              <Route path="/manage-project" element={<ManageProjects />} />
              <Route path="/company-register" element={<CompanyDetailsForm />} />
              <Route path="/companylist" element={<CompanyList />} />
              <Route path="/create-doctor" element={<DoctorDetailsForm />} />
              <Route path="/doctorlist" element={<DoctorList />} />
              <Route path="/staff-register" element={<StaffDetailsForm />} />
              <Route path="/stafflist" element={<StaffList />} />
              <Route path="/diagnosticslist" element={<DiagnosticsBookingList />} />
              <Route path="/diagnosticsacceptedlist" element={<DiagnosticsAcceptedBooking />} />
              <Route path="/diagnosticsrejectedlist" element={<DiagnosticsRejectedBooking />} />
              <Route path="/doctoracceptedlist" element={<AcceptedAppointmentsList />} />
              <Route path="/doctorrejectedlist" element={<RejectedAppointmentsList />} />
              <Route path="/appintmentlist" element={<DoctorAppointmentList />} />
              <Route path="/appintmentbooking" element={<AppointmentBookingForm />} />
              <Route path="/diagnostic-center/:id" element={<DiagnosticDetail />} />
              <Route path="/diagnosticpending" element={<DiagnosticsPendingBooking />} />
              <Route path="/doctorpendingbookings" element={<DoctorAppointmentListPending />} />
              <Route path="/categoryform" element={<CategoryForm />} />
              <Route path="/categorylist" element={<CategoryList />} />
              <Route path="/add-product" element={<CreateProductForm />} />
              <Route path="/productlist" element={<ProductList />} />
              <Route path="/allorders" element={<BookingList />} />
              <Route path="/pendingorders" element={<PendingBookingList />} />
              <Route path="/completedorders" element={<CompletedBookingList />} />
              <Route path="/cancelledorders" element={<CancelledBookingList />} />
              <Route path="/companysidebar" element={<CompanySidebar />} />
              <Route path="/staff-history/:staffId" element={<StaffHistory />} /> {/* Route for StaffHistory */}
              <Route path="/book-diagnostic" element={<DiagnosticBookingForm />} />
              <Route path="/coupons" element={<CouponsPage />} />
              <Route path="/couponshistory" element={<CouponHistoryTable />} />
              <Route path="/create-coupon" element={<CreateCoupon />} />
              <Route path="/upload-docs" element={<UploadDocuments />} />
              <Route path="/docs" element={<DocumentTable />} />
              <Route path="/user-coupons" element={<AllUserCoupons />} />

              <Route path="/create-category" element={<CreateCategory />} />
              <Route path="/categorylist" element={<CategoryList />} />
              <Route path="/create-poster" element={<CreatePoster />} />
              <Route path="/posterlist" element={<PosterList />} />
              <Route path="/create-logo" element={<CreateLogo />} />
              <Route path="/logolist" element={<LogoList />} />
              <Route path="/create-businesscard" element={<CreateBusinessCard />} />
              <Route path="/create-plan" element={<CreatePlan />} />
              <Route path="/planlist" element={<PlanList />} />
              <Route path="/userplanlist" element={<UsersPlansList />} />
              <Route path="/orderlist" element={<OrdersList />} />
              <Route path="/create-privacy" element={<PrivacyPolicyForm />} />
              <Route path="/get-policy" element={<PrivacyPolicyPage />} />
              <Route path="/aboutus" element={<AboutUsFormPage />} />
              <Route path="/getaboutus" element={<GetAboutUsPage />} />
              <Route path="/contactus" element={<ContactUsPage />} />
              <Route path="/getcontactus" element={<GetContactUsPage />} />
              <Route path="/create-vendor" element={<CreateVendor />} />
              <Route path="/vendorlist" element={<VendorList />} />
              <Route path="/vendordocumentlist" element={<VendorDocumentList />} />
              <Route path="/redeemed-coupons" element={<RedeemedCouponsList />} />
              <Route path="/payment" element={<VendorInvoiceList />} />
              <Route path="/rcvdpayment" element={< ReceivedPayments />} />
              <Route path="/allpayments" element={< AllPayments />} />
              <Route path="/vendor/:id" element={<VendorDetail />} />
              <Route path="/users" element={<UserList />} />
              <Route path="/users/:userId" element={<UserDetail />} />
              <Route path="/add-bulk-quiz" element={<BulkQuizUploader />} />
              <Route path="/quizzes" element={<AllQuizzesTable />} />
              <Route path="/add-bulk-funfacts" element={<BulkFunFactUploader />} />
              <Route path="/allfanfacts" element={<AllFunFactsTable />} />



              <Route path="/addemployee" element={<AddEmployeePage />} />
              <Route path="/employeelist" element={<EmployeeList />} />
              <Route path="/attendancelist" element={<AttendanceList />} />
              <Route path="/leavelist" element={<LeavesList />} />
              <Route path="/permissions" element={<Permissions />} />
              <Route path="/today-attendance" element={<TodayAttendance />} />
              <Route path="/pendings-attendance" element={<PendingAttendance />} />
              <Route path="/absent-today" element={<AbsentToday />} />
              <Route path="/late-today" element={<LateToday />} />
              <Route path="/attendance-capture" element={<AttendanceCapture />} />
              <Route path="/myattendance" element={<MyAttendance />} />
              <Route path="/leaves-report" element={<LeavesReport />} />
              <Route path="/shift" element={<ShiftManagement />} />
              <Route path="/shiftlist" element={<ShiftList />} />
              <Route path="/assignlocation" element={<AssignLocation />} />
              <Route path="/admin-employee-locations" element={<AdminEmployeeLocations />} />
              <Route path="/addlocation" element={<AddLocationPage />} />
              <Route path="/locationlist" element={<LocationListPage />} />
              <Route path="attedancesummary" element={<AttendanceSummary />} />
              {/* <Route path="/empmanagement" element={<EmpManagment />} */}
              <Route path="/payroll" element={<PayRoll />} />
              <Route path="/useractivity" element={<UserActivity />} />
              <Route path="/departmentdashboard" element={<DepartmentDashboard />} />
              <Route path="/roledashboard" element={<RoleDashboard />} />
              <Route path="/employeedetailsmodel" element={<EmployeeDetailsModal />} />
              <Route path="/useraccess" element={<UserAccessManagement />} />
              <Route path="/client-requests" element={<ClientRequests />} />

              <Route path="/jobpost" element={<JobPost />} />
              <Route path="/score" element={<Score />} />
              <Route path="/sendoffer" element={<SendOffer />} />
              <Route path="/job-applicants" element={<JobApplicants />} />
              <Route path="/assessment-manager" element={<AssessmentManager />} />
              {/* <Route path="/documents" element={<PersonalDocuments />} /> */}
              <Route path="/admin-notifications" element={<AdminNotifications />} />
              <Route path="/medical" element={<Medical />} />
              <Route path="/personaldocuments" element={<PersonalDocuments />} />
              <Route path="/employee-resignation" element={<EmployeeResignation />} />
              <Route path="/recruitment-dashboard" element={<RecruitmentDashboard />} />
              <Route path="/all-jobs" element={<AllJobs />} />
              <Route path="/applied-jobs" element={<AppliedJobs />} />
              <Route path="/interview" element={<Interview />} />
              <Route path="/letters" element={<Letters />} />
              <Route path="/candidate-documents" element={<CandidateDocuments />} />
              <Route path="/candidate-personal-documents" element={<CandidatePersonalDocuments />} />
              <Route path="/employee-journey" element={<EmployeeJourney />} />
              <Route path="/all-expensives" element={<AllExpensives />} />
              <Route path="/occasions" element={<Occasions />} />
              <Route path="/pending-leaves" element={<PendingLeaves />} />
              <Route path="/approved-leaves" element={<ApprovedLeaves />} />
              <Route path="/rejected-leaves" element={<RejectedLeaves />} />
              <Route path="/regularization" element={<Regularization />} />
              <Route path="/all-medical-certificates" element={<AllMedicalCertificate />} />
              <Route path="/holidays-calendar" element={<HolidaysCalendar/>}/>
              <Route path="/bank-reports" element={<BankReports />} />
              <Route path="/employee-resignation" element={<EmployeeResignation />} />
              <Route path="/approved-resignations" element={<ApprovedResignations />} />
              <Route path="/rejected-resignations" element={<RejectedResignations />} />
              <Route path="/pending-resignations" element={<PendingResignations />} />
              <Route path="/events" element={<Events />} />
              <Route path="/over-time" element={<OverTime />} />
              <Route path="/comp-off-settings" element={<CompOffSettings />} />
           
           


            </Routes>
          </AdminLayout>
        }
      />
    </Routes>
  );
}

export default App;
